<script>
	import Header from "./Header.svelte";
	import Footer from "./Footer.svelte";
	import Banner from "./Banner.svelte";
	import Projects from "./Projects.svelte";
	import Socials from "./Socials.svelte";
	import Viz2 from "./Viz-2.svelte";
	export let siteName = "CK.com";
</script>

<Header {siteName} />
<Viz2 />

<main class="main-content">
	<Banner bannerTitle="Web Development" />
	<Projects />
	<Socials />
</main>

<Footer {siteName} />

<style lang="scss">
	main {
		z-index: 10;
		padding: 20px;
	}
</style>
